import React, { useEffect, useState } from 'react';
import "../App.css";
import hdfcLoader from '../assets/loader.gif';
import logo from '../assets/logo_01.png';
import LoginForm from '../components/LoginForm';
import OtpForm from '../components/OtpForm';
import "../Loogin.css";
import { dwsLogin, sendOtp, user } from '../services/apiService';
;

const Login: React.FC = () => {

    const path = window.location.pathname;
    const id = path?.split('/').filter(part => part)[0]
    const [showOTPInput, setShowOTPInput] = useState(false);
    const [userDob, setUserDob] = useState<string>('');
    const [message, setMessage] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [validId, setValidId] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const displayLoader = (value: boolean) => {
        setShowLoader(value);
    }

    useEffect(() => {
        //call user api for user's details
        const data = {
            "source": process.env.REACT_APP_SOURCE,
            "userid": process.env.REACT_APP_USERID,
            "password": process.env.REACT_APP_PASSWORD,
            "appname": process.env.REACT_APP_APPNAME
        };
        if (id) {
            const userData = {
                id: id
            };

            setShowLoader(true);
            user(userData).then((response) => {
                setShowLoader(false);
                if (response?.success) {
                    setUserDob(response?.success?.data?.dob);
                    setPhoneNumber(response?.success?.data?.phone_number);
                    sessionStorage.setItem('txnid', response?.success?.data?.txnid);
                    localStorage.setItem('token', response?.success?.data?.token);

                    if (response?.success?.data?.confirmation) {
                        setMessage("User already registered");
                    } else {
                        setValidId(true);
                        setMessage("Dear customer, We've received email for your policy from unregsitered ID. Please validate yourself for processing email.");
                    }
                } else if (response?.error) {
                    setMessage('Invalid URL');
                } else {
                    setMessage('Something Went Wrong, Please try again later');
                }
            });
        } else {
            setMessage("Invalid URL");
        }

    }, []);

    const displayOtpForm = (value: boolean) => {
        setShowOTPInput(value);
    }

    const otpSend = () => {
        const data = {
            "phoneNumber": phoneNumber,
            "customerId": id
        }
        return sendOtp(data)
    }

    return (
        <div>
            <div className='headerDiv'>
                <header className="header">
                    <img className="HdfcLogo" src={logo} />
                </header>
            </div>

            {/* <div className="backgroundColor"> */}
            <div style={{ marginTop: '6vh' }}>
                <p className="Title">{message}</p>

                {showLoader ? (
                    <img className="loader" src={hdfcLoader} alt="" />
                ) : (
                    <>
                        {validId ? (
                            <div className="login-container">
                                <div >
                                    <h5 className="TitleTwo">Verify</h5>
                                </div>
                                {showLoader ? (
                                    <img className="loader" src={hdfcLoader} alt="" />
                                ) : (
                                    <>
                                        {!showOTPInput ? (
                                            <LoginForm
                                                storedDob={userDob}
                                                otpSend={otpSend}
                                                displayOtpForm={displayOtpForm}
                                                phoneNumber={phoneNumber}
                                                displayLoader={displayLoader}
                                            />
                                        ) : (
                                            <OtpForm
                                                phoneNumber={phoneNumber}
                                                id={id}
                                                otpSend={otpSend}
                                                displayLoader={displayLoader}
                                            />

                                        )}
                                    </>
                                )}
                                {/* </div> */}
                            </div>
                        ) : <></>}
                    </>
                )}
                {validId ? (
                    <p className="Title">If you wish to update the email address in your policy, please click on the link to raise a Service Request (SR): <a href="https://bit.ly/3PiKTkT" target='_blank' rel='noopener noreferrer'>https://bit.ly/3PiKTkT</a></p>
                )
                    :
                    (<></>)}
            </div>

            <div className="footer">
                <h6 style={{ marginTop: 10 }}>© 2023, HDFC Life. All rights reserved | Powered by Data Labs</h6>
            </div>
        </div>

    );

};


export default Login;
